const SUB_DOMAIN = 'www.';

class URLHelper {
  public static isValidUrl(url: string): boolean {
    try {
      new URL(url);

      return true;
    } catch (err) {
      return false;
    }
  }

  public static getDomainName(siteName: string): string {
    try {
      const url = new URL(siteName);

      return url.hostname.replace(SUB_DOMAIN, '');
    } catch (err) {
      return siteName;
    }
  }
}

export default URLHelper